// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Luna Point 2
 * Service Luna Point 2
 * Version: v.0.0.0
 */import { NullFilter } from './NullFilter';

export const EthnicGroupFilter = {  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
...NullFilter,} as const
export type EthnicGroupFilter = typeof EthnicGroupFilter[keyof typeof EthnicGroupFilter];
